import React, { useState } from "react";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import CheckboxCheckedIcon from "src/icons/CheckBoxCheckedIcon";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import HyroDialog from "@hyro-components/Dialogs/HyroUiDialog";
import {
  SWITCH_SETUP_BODY,
  SWITCH_SETUP_BODY_WITH_CUSTOMS,
  SWITCH_SETUP_CHECKBOX_LABEL,
  SWITCH_SETUP_SUBMIT
} from "./AnalyticsSettings.consts";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckboxCheckedIcon fontSize="small" />;

const SwitchSetupDialog = ({ open, setupName, hasCustomBenchmarks, onConfirm, onCancel }) => {
  const [keepCustoms, setKeepCustoms] = useState(true);

  const handleConfirm = () => {
    onConfirm(hasCustomBenchmarks && keepCustoms);
    setKeepCustoms(true);
  };

  const handleCancel = () => {
    onCancel();
    setKeepCustoms(true);
  };

  return (
    <HyroDialog
      open={open}
      variant="transactional"
      title={`Switching agent setup to ${setupName}`}
      submitButtonText={SWITCH_SETUP_SUBMIT}
      handleSubmit={handleConfirm}
      handleCancel={handleCancel}
      handleClose={handleCancel}
      showCloseButton
      testId="switch-setup-dialog"
    >
      <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
        {hasCustomBenchmarks ? SWITCH_SETUP_BODY_WITH_CUSTOMS : SWITCH_SETUP_BODY}
      </Typography>
      {hasCustomBenchmarks && (
        <FormControlLabel
          control={
            <Checkbox
              icon={icon}
              disableRipple
              checkedIcon={checkedIcon}
              checked={keepCustoms}
              onChange={(e) => setKeepCustoms(e.target.checked)}
              color="primary"
            />
          }
          label={SWITCH_SETUP_CHECKBOX_LABEL}
          sx={{ mt: 1 }}
        />
      )}
    </HyroDialog>
  );
};

export default SwitchSetupDialog;
